module.exports = __webpack_public_path__ + "src/routes/aboutus/aboutUsHead.png?018051c5";


//////////////////
// WEBPACK FOOTER
// ./src/routes/aboutus/aboutUsHead.png
// module id = 2828
// module chunks = 1